var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'offers', query: { company_id: _vm.payload.id, company_name: _vm.payload.name } }}},[_c('a',{staticClass:"button is-info is-outlined custom_operation_btn"},[_vm._v("Offers")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }